// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as coreui from '@coreui/coreui'
import "./controllers"
import "./fontawesome"

window.coreui = coreui
